import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const _savedToken = typeof localStorage !== "undefined" && localStorage.getItem("mesabi_token");
if (_savedToken) api.defaults.headers.common["Authorization"] = `Bearer ${_savedToken}`;

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem("mesabi_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("mesabi_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export const CURRENCY_SYMBOLS = {
  USD: "$", INR: "₹", GBP: "£", SGD: "S$", AED: "AED ",
  CHF: "CHF ", JPY: "¥", NGN: "₦", EUR: "€",
};

export function fmt(v, ccy = "USD", decimals = 0) {
  const sym = CURRENCY_SYMBOLS[ccy] || (ccy ? ccy + " " : "");
  if (v === null || v === undefined || isNaN(v)) return "—";
  const n = Number(v).toLocaleString("en-US", {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  });
  return `${sym}${n}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ROLE_LABELS = {
  employee: "Employee",
  hr_business_partner: "HR Business Partner",
  mobility_specialist: "Global Mobility Specialist",
  comp_admin: "Compensation Administrator",
  tax_reviewer: "Tax Reviewer",
  system_administrator: "System Administrator",
  auditor: "Read-Only Auditor",
};
